<template>
  <div class="slider-wrapper">
    <div class="slider-container-box">
      <!-- Swiper con datos dinámicos de la BD -->
      <swiper v-if="slidersDinamicos && slidersDinamicos.length > 0" :options="computedSwiperOptions" class="gallery-top" ref="swiperTop">
        <swiper-slide 
          v-for="slide in slidersDinamicos" 
          :key="slide.id" 
          class="dynamic-slide-auto"
        >
          <!-- Imagen responsive que dicta la altura AUTO exacta del slider sin franjas -->
          <img 
            :src="getSlideImagenUrl(slide)" 
            class="slide-img-responsive" 
            :alt="slide.titulo || 'Banner Slider'" 
          />

          <!-- Capa de oscurecimiento u overlay para legibilidad (solo si tiene texto) -->
          <div v-if="slide.titulo || slide.subtitulo || slide.texto_boton" class="slide-overlay-mask"></div>

          <!-- Contenido textual y botón CTA -->
          <div v-if="slide.titulo || slide.subtitulo || slide.texto_boton" class="slide-overlay-content">
            <h2 v-if="slide.titulo" class="slide-title">{{ slide.titulo }}</h2>
            <p v-if="slide.subtitulo" class="slide-subtitle">{{ slide.subtitulo }}</p>
            <a v-if="slide.texto_boton" :href="slide.url_boton || '#'" class="btn btn-primary slide-btn">
              {{ slide.texto_boton }} <i class="fa fa-arrow-right ml-1"></i>
            </a>
          </div>
        </swiper-slide>
        
        <div v-if="slidersDinamicos.length > 1" class="swiper-button-next swiper-button-white" slot="button-next"></div>
        <div v-if="slidersDinamicos.length > 1" class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
      </swiper>
    </div>
  </div>
</template>

<script>
import 'swiper/swiper-bundle.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import axios from 'axios'

export default {
  components: {
    swiper,
    swiperSlide
  },
  name: 'slider',
  data() {
    return {
      isMobile: false,
      slidersDinamicos: []
    }
  },
  computed: {
    computedSwiperOptions() {
      let allowLoop = this.slidersDinamicos && this.slidersDinamicos.length > 1;
      return {
        spaceBetween: 0,
        loop: allowLoop,
        autoplay: allowLoop ? {
          delay: 5000,
          disableOnInteraction: false
        } : false,
        navigation: allowLoop ? {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        } : false
      }
    }
  },
  methods: {
    checkMobile() {
      if (typeof window !== 'undefined') {
        this.isMobile = window.innerWidth <= 768;
      }
    },
    cargarSlidersPublicos() {
      let me = this;
      let dom = (me.$store && me.$store.state && me.$store.state.dominio) ? me.$store.state.dominio : 'https://sistema.empaqueslupa.com';
      let url = dom + '/slider/publicos?ubicacion=principal';

      axios.get(url).then(response => {
        if (response.data && response.data.length > 0) {
          me.slidersDinamicos = response.data;
        }
      }).catch(err => {
        console.log("Error al cargar sliders dinámicos", err);
      });
    },
    getSlideImagenUrl(slide) {
      if (!slide) return '';
      let path = (this.isMobile && slide.imagen_movil) ? slide.imagen_movil : slide.imagen;
      return this.getImagenUrl(path);
    },
    getImagenUrl(path) {
      if (!path) return '';
      let normalized = path.replace(/\\/g, '/');
      if (normalized.startsWith('http://') || normalized.startsWith('https://')) return normalized;
      let cleanPath = normalized.startsWith('/') ? normalized : '/' + normalized;
      let dom = (this.$store && this.$store.state && this.$store.state.dominio) ? this.$store.state.dominio : 'https://sistema.empaqueslupa.com';
      return dom + cleanPath;
    }
  },
  created() {
    this.checkMobile();
    this.cargarSlidersPublicos();
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.checkMobile);
    }
  },
  beforeDestroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.checkMobile);
    }
  }
}
</script>

<style lang="scss" scoped>
  .slider-wrapper {
    width: 100%;
    height: auto !important;
    position: relative;
    overflow: hidden;
  }

  .slider-container-box {
    width: 100%;
    height: auto !important;
    position: relative;
  }

  .gallery-top {
    width: 100%;
    height: auto !important;
  }

  .swiper-container {
    width: 100%;
    height: auto !important;
    background-color: transparent !important;
  }

  .dynamic-slide-auto {
    position: relative;
    width: 100%;
    height: auto !important;
    display: block;
  }

  .slide-img-responsive {
    width: 100%;
    height: auto !important;
    display: block;
    object-fit: contain;
  }

  .slide-overlay-mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, rgba(0, 0, 0, 0.65) 0%, rgba(0, 0, 0, 0.2) 60%, rgba(0, 0, 0, 0) 100%);
    z-index: 2;
    pointer-events: none;
  }

  .slide-overlay-content {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 3;
    padding: 0 8%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    color: #ffffff;

    .slide-title {
      font-size: 2.5rem;
      font-weight: 800;
      margin-bottom: 12px;
      line-height: 1.15;
      color: #ffffff;
      text-shadow: 0 2px 8px rgba(0,0,0,0.6);
      @media (max-width: 768px) {
        font-size: 1.4rem;
        margin-bottom: 6px;
      }
    }
    .slide-subtitle {
      font-size: 1.15rem;
      margin-bottom: 20px;
      color: #f1f5f9;
      text-shadow: 0 1px 4px rgba(0,0,0,0.6);
      @media (max-width: 768px) {
        font-size: 0.85rem;
        margin-bottom: 10px;
      }
    }
    .slide-btn {
      padding: 10px 24px;
      font-weight: 700;
      font-size: 0.95rem;
      border-radius: 30px;
      background: linear-gradient(45deg, #713083, #cc161d);
      color: #ffffff;
      border: none;
      display: inline-block;
      text-decoration: none;
      box-shadow: 0 4px 15px rgba(113, 48, 131, 0.4);
      transition: all 0.3s ease;
      @media (max-width: 768px) {
        padding: 5px 14px;
        font-size: 0.75rem;
      }
      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 25px rgba(204, 22, 29, 0.5);
        color: #ffffff;
        text-decoration: none;
      }
    }
  }

  .swiper-slide {
    height: auto !important;
  }
</style>